module.exports = __webpack_public_path__ + "assets/FI.6d7fa1e9.png";